import { createAuthClient } from "better-auth/react";
import { migrationApiUrl } from "./env";

// get the server base URL (origin) from the API URL.
// e.g. "http://localhost:8082/graphql" → "http://localhost:8082"
const serverBaseUrl = migrationApiUrl
  ? new URL(migrationApiUrl).origin
  : undefined;

export const authClient = createAuthClient({
  baseURL: serverBaseUrl,
});

export const { signIn, signOut, useSession } = authClient;
